import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web--source/slate/Button";
import { Tooltip } from "@faire/web--source/slate/Tooltip";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";

import { IDottedTooltipProps } from "./SharedTooltipProps";

export const DesktopDottedTooltip: React.FC<IDottedTooltipProps> = (props) => {
  return (
    <Tooltip
      position={props.desktopPosition ?? "top"}
      width={props.desktopWidth ?? 350}
      targetNode={
        <Typography
          textDecoration="dottedUnderline"
          variant="paragraphSansMedium"
        >
          {props.text}
        </Typography>
      }
      contents={[
        {
          title: props.tooltipTitle,
          body: props.tooltipText,
        },
      ]}
      action={
        props.tooltipCTA ? (
          <Button
            variant="tertiary"
            tertiaryColor={Core.surface.inverse}
            linkTo={props.tooltipCTALink}
            target={props.openCTAInNewTab ? "_blank" : undefined}
          >
            {props.tooltipCTA}
          </Button>
        ) : undefined
      }
    />
  );
};
